import { LOGIN_CONSTANT_TO_CHECK } from "../models/constants/Core.Constants";
import { storageService } from "../services/Storage.service";

export const useAuth = () => {
  let user = storageService.getItemByLocalstorage(LOGIN_CONSTANT_TO_CHECK);

  return user !== undefined && user !== null;
};
